import{a as r}from"./chunk-JFXZ246Y.js";function s(...e){return r(n,e)}function n(e,t,o){return{...e,[t]:o}}export{s as a};
